import * as React from 'react'

import { Icon } from '~/components/icon/Icon'

export const BadgeIcon = (props: React.ComponentProps<typeof Icon>) => (
  <Icon size="sm" {...props} />
)
